import styled from 'styled-components';
import { asRem } from 'utils';
import { colors, breakpoints } from 'components/Theme';
import { Card } from 'Component';

export default styled(Card)`
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  align-items: center;
  background-color: ${colors.blue.c800};
  overflow: visible;
  height: auto;

  @media (min-width: ${breakpoints.md}) {
    flex-direction: row;
    height: ${asRem(200)};
    align-items: flex-start;
  }

  .sleep-right-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: ${asRem(24)};

    @media (min-width: ${breakpoints.md}) {
      margin-bottom: 0;
    }
  }

  .course-tag {
    margin-bottom: -${asRem(16)};
  }

  .sleep-left-col {
    color: ${colors.white.c500};
    margin-right: 0;
    text-align: center;

    @media (min-width: ${breakpoints.md}) {
      text-align: left;
      margin-right: ${asRem(16)};
    }
  }

  .sleep-image {
    aspect-ratio: ${asRem(202)} / ${asRem(168)};
    width: ${asRem(202)};
    margin-top: -${asRem(135)};

    @media (min-width: ${breakpoints.md}) {
      margin-top: -${asRem(100)};
    }
  }

  .sleep-button {
    margin-top: ${asRem(16)};
  }
`;
